var _path, _path2, _circle, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileUploadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 55,
    viewBox: "0 0 49 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6C0.5 2.96243 2.96243 0.5 6 0.5H29.7929L34.6464 5.35355L39.5 10.2071V42C39.5 45.0376 37.0376 47.5 34 47.5H6C2.96243 47.5 0.5 45.0376 0.5 42V6Z",
    fill: "#F3F4F6",
    stroke: "#E5E6E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7929 10.5H33C31.067 10.5 29.5 8.933 29.5 7V1.20711L38.7929 10.5Z",
    fill: "#E5E6EC",
    stroke: "#E5E6EA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 42,
    r: 13,
    fill: "#141826"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36 49V44M36 44L38 46.4M36 44L34 46.4",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1 46C29.8765 45.581 29 44.4505 29 43.1216C29 41.5506 30.225 40.2568 31.8 40.0881C31.8 40.0819 31.8 40.0757 31.8 40.0695C31.8 37.822 33.6804 36 36 36C38.3196 36 40.2 37.822 40.2 40.0695C40.2 40.0757 40.2 40.0819 40.2 40.0881C41.775 40.2568 43 41.5506 43 43.1216C43 44.4505 42.1235 45.581 40.9 46",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadIcon);
export default __webpack_public_path__ + "static/media/file_upload_icon.8c4384ee.svg";
export { ForwardRef as ReactComponent };